

import { namespace, State } from "vuex-class"
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"

// @ts-ignore
import vSelect from "vue-select"
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { Case, Field, TemplateDetails } from "@/types"

import api from "@/services/api"

import HubRecordViewService from "@/services/hubRecordViewService"

import SkeletonLoader from "../SkeletonLoader.vue"
import CaseList from "@/components/CaseList/CaseList.vue"
import DataCache from "@/caching/caching"

const caseStore = namespace("cases")
const setup = namespace("setup")

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"case-list": CaseList,
		"skeleton": SkeletonLoader,
		"v-select": vSelect
	}
})
export default class RecordView extends Vue {
	@Prop()
	value: any;

	@Prop()
	edit!: boolean

	@State private readonly templateCache!: DataCache<TemplateDetails>

	@caseStore.Action("detailsLoad")
	private detailsLoad!: () => void;

	@setup.Action loadFieldsIfUnloaded!: () => Promise<Field[]>

	views: any[] = [];

	activeView: any = null;
	loadingCases: boolean = true;
	errorLoading: boolean = false;
	errorUpdating: boolean = false;
	displayRecords: Case[] = [];
	hubDashboardService: HubRecordViewService = new HubRecordViewService();

	public async mounted () {
		await this.loadFieldsIfUnloaded()
		this.onEditChanged()
	}

	public beforeDestroy () {
		this.closeHubConnection()
	}

	public async rowClick (item: any) {
		this.$router.push({ path: `/cases/${item.caseNumber}` })
	}

	@Watch("edit")
	private async onEditChanged () {
		await this.templateCache.fetchIfNeeded()
		if (this.edit) {
			this.setEditMode()
		} else {
			this.setViewMode()
		}
	}

	private async setEditMode () {
		this.closeHubConnection()

		this.views = await api.caseViewsGet()
	}

	private async setViewMode () {
		this.loadingCases = true
		this.errorLoading = false

		try {
			if (this.value && this.value.viewId) {
				if (!this.activeView || this.activeView.id !== this.value.viewId) {
					api.caseViewsGet()
						.then(views => {
							this.views = views

							if (this.views) {
								this.activeView = this.views.find(v => v.id === this.value.viewId)
							}
						})
				}

				this.displayRecords = await api.caseList(this.value.viewId)
			}
		} catch (err) {
			this.errorLoading = true
		}

		this.loadingCases = false
		await this.openHubConnection()
	}

	private async openHubConnection () {
		if (!this.value || !this.value.viewId) {
			return
		}

		try {
			const connection = await this.hubDashboardService.openConnection(this.value.viewId)

			if (connection) {
				connection.on("recordView", (data: Case[]) => {
					this.displayRecords = data
					this.errorUpdating = false
				})

				connection.on("recordViewError", (err: String) => {
					console.log(err)
					this.errorUpdating = true
				})
			}
		} catch (err) {
			this.errorUpdating = true
		}
	}

	private closeHubConnection () {
		if (!this.hubDashboardService) {
			return
		}

		this.hubDashboardService.closeConnection()
	}

	@Emit("input")
	private viewChanged (viewId: string) {
		return { ...this.value, viewId }
	}
}
